import React from 'react';
import i18n from '../../../i18n';
import styles from './Toolbar.module.scss';
import { Icon } from '@ui';

/**
 * Toolbar standard sopra le liste/tabelle: slot filtri a sinistra,
 * ricerca, spacer, azioni a destra (es. AppButton "Aggiungi").
 *
 * Pattern unificato che sostituisce le toolbar fatte a mano con
 * Bootstrap grid (`row`/`col-sm-*`) nelle liste CRUD.
 *
 * Props:
 * - filters:        node renderizzato a sinistra (select, chip, ecc.)
 * - searchValue:    valore controllato del campo ricerca (se omesso, niente search)
 * - onSearchChange: (value: string) => void
 * - searchPlaceholder
 * - actions:        node a destra (bottoni bulk/aggiungi)
 * - children:       alternativa libera al posto degli slot
 */
export default function Toolbar({
  filters,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  actions,
  children,
}) {
  const hasSearch = typeof onSearchChange === 'function';

  return (
    <div className={styles.toolbar}>
      {children}
      {filters ? <div className={styles.filters}>{filters}</div> : null}

      {hasSearch ? (
        <label className={styles.searchInput}>
          <Icon name="search" aria-hidden="true" />
          <input
            type="text"
            value={searchValue ?? ''}
            placeholder={searchPlaceholder ?? i18n.t('cerca', { defaultValue: 'Cerca…' })}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </label>
      ) : null}

      <div className={styles.spacer} />

      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
